<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template slot="item" slot-scope="props">
              <router-link
                :to="'/' + props.item.to"
                :disabled="props.item.disabled"
                v-bind:class="{
                  'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                    props.item.disabled,
                }"
                >{{ props.item.text }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{ responseError }}</span>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                readonly
                :rules="[() => !!queryParams.shopId || 'Shop is required.']"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :disabled="true"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.month"
                    label="Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.month"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-radio-group
                v-model="queryParams.balanceType"
                :mandatory="false"
                row
              >
                <v-radio label="All" value="ALL"></v-radio>
                <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1" style="overflow-x: auto; max-width: 100%;">
        <v-card style="width: fit-content;">
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <h3 style="margin:0px;color:blue" id="counter">
                Profit And Loss
              </h3>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >
                Shop Code : {{ shopCode }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >
                Date : {{ currentDate }}
              </p>
            </div>
          </v-flex>
          <br />
          <v-flex xs12 ml-2 pt-4>
            <v-layout row pt-4>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Code
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Name
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Nature</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget(%)
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount(%)</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget(%)
                  </h4>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 ml-2>
            <div style="width:100%;height:3px;background-color: blue;"></div>
          </v-flex>

          <!-- Start Revenue -->
          <income-statement-session
            :header="'Income'"
            :sessionName="'Revenue'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'REVENUE' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="incomeStatement.totalRevenue"
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="incomeStatement.totalRevenueBudget"
            :showListLoading="showListLoading"
          />
          <!-- End Revenue -->

          <!-- Start Cost of Good Sold -->
          <income-statement-session
            :sessionName="'Cost Of Good Sold'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'COST_OF_GOOD_SOLD' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="incomeStatement.totalCostOfGoodSold"
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="incomeStatement.totalCostOfGoodSoldBudget"
            :showListLoading="showListLoading"
            :footer="'Gross Profit'"
            :footerAmount="incomeStatement.grossProfit"
            :footerBudget="incomeStatement.grossProfitBudget"
            :useBgColor="true"
          />
          <!-- End Cost of Good Sold -->

          <!-- Start Other Income -->
          <income-statement-session
            :sessionName="'Other Income'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'OTHER_INCOME' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="true"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="incomeStatement.totalOtherIncome"
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="incomeStatement.totalOtherIncomeBudget"
            :showListLoading="showListLoading"
            :footer="'Total Income'"
            :footerAmount="
              incomeStatement.grossProfit + incomeStatement.totalOtherIncome
            "
            :footerBudget="
              incomeStatement.grossProfitBudget +
                incomeStatement.totalOtherIncomeBudget
            "
          />
          <!-- End Other Income -->

          <!-- Start Administration Expenses -->
          <income-statement-session
            :header="'Less Expense'"
            :sessionName="'Administration Expenses'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'ADMINISTRATION_EXPENSES' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="true"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="incomeStatement.totalAdministrationExpense"
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="
              incomeStatement.totalAdministrationExpenseBudget
            "
            :showListLoading="showListLoading"
          />
          <!-- End Administration Expenses -->

          <!-- Start Selling & Distribution Expenses -->
          <income-statement-session
            :sessionName="'Selling & Distribution Expenses'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'SELLING_DISTRIBUTION_EXPENSES' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="true"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="
              incomeStatement.totalSellingAndDistributionExpense
            "
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="
              incomeStatement.totalSellingAndDistributionExpenseBudget
            "
            :showListLoading="showListLoading"
          />
          <!-- End Selling & Distribution Expenses -->

          <!-- Start Other Expenses -->
          <income-statement-session
            :sessionName="'Other Expenses'"
            :accountList="
              incomeStatement.incomeStatementAccountList.filter(
                (v) =>
                  v.sessionName === 'OTHER_EXPENSES' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="true"
            :baseAmount="incomeStatement.totalRevenue"
            :sessionTotalAmount="incomeStatement.totalOtherExpenses"
            :baseBudget="incomeStatement.totalRevenueBudget"
            :sessionTotalBudget="incomeStatement.totalOtherExpensesBudget"
            :footer="'Total Expenses'"
            :footerAmount="
              incomeStatement.totalAdministrationExpense +
                incomeStatement.totalSellingAndDistributionExpense +
                incomeStatement.totalOtherExpenses
            "
            :footerBudget="
              incomeStatement.totalAdministrationExpenseBudget +
                incomeStatement.totalSellingAndDistributionExpenseBudget +
                incomeStatement.totalOtherExpensesBudget
            "
            :footer2="'Net Profit or Loss'"
            :footer2Amount="incomeStatement.profitLossAmount"
            :footer2Budget="incomeStatement.profitLossAmountBudget"
            :footer2UseBgColor="true"
            :showListLoading="showListLoading"
          />
          <!-- End Other Expenses -->
        </v-card>
      </v-flex>

      <v-flex sm12>
        <div class="text-xs-center">
          <v-btn
            color="primary"
            :loading="saveLoading"
            @click="printInvoice('incomestatementPrint')"
          >
            Print
            <v-icon right>save</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- IS print hidden area -->
    <IncomeStatementPrint
      id="incomestatementPrint"
      :isModel="incomeStatement"
      :fromMonth="queryParams.fromMonth"
      :toMonth="queryParams.toMonth"
      :shopCode="shopCode"
      :shopName="shopName"
      :balanceType="queryParams.balanceType"
    ></IncomeStatementPrint>
    <!-- End print  -->
  </v-container>
</template>
<script>
import { incomeStatementService } from "../../services/income-statement-service";
import { shopService } from "../../services/shop-service";
import { IncomeStatement } from "../../models/model";
import { commonService } from "../../services/common-service";
import IncomeStatementSession from "./IncomeStatementSession";
import IncomeStatementPrint from "./IncomeStatementPrint.vue";
export default {
  name: "IncomeStatementDetail",
  components: { IncomeStatementSession, IncomeStatementPrint },
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Income Statement",
        disabled: true,
      },
      {
        text: "Income Statement Detail",
        disabled: true,
      },
    ],
    queryParams: {
      shopId: "",
      month: new Date().toISOString().substr(0, 7),
      balanceType: "ALL",
    },
    currentDate: new Date().toISOString().slice(0, 10),
    responseError: "",
    saveLoading: false,
    shopCode: "",
    shopList: [],
    incomeStatement: new IncomeStatement(),
    oldIncomeStatement: new IncomeStatement(),
    previewFilterObj: new IncomeStatement(),
    decimalFormat: "",
    menu: false,
    date: new Date(),
    headers: [
      { text: "Account Code", sortable: false, width: "1%" },
      { text: "Account Name", sortable: false, width: "1%" },
      { text: "Nature", sortable: false, width: "1%" },
      { text: "Amount", sortable: false, width: "1%", align: "right" },
      { text: "", sortable: false, width: "1%" },
    ],
  }),

  created() {
    //for deep linking
    const id = this.$route.params.id;
    if (id == "new") {
      // new IncomeStatement
    } else {
      this.getIncomeStatementDetail(id);
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    getIncomeStatementDetail(id) {
      incomeStatementService.getIncomeStatementById(id).then((res) => {
        this.incomeStatement = res.data;
        this.shopCode = this.incomeStatement.shop.code;
        this.queryParams.shopId = this.incomeStatement.shopId;
        let date = new Date(
          this.incomeStatement.month + " 2 " + this.incomeStatement.year
        );
        this.queryParams.month = date.toISOString().substr(0, 7);
        this.oldIncomeStatement = JSON.parse(JSON.stringify(res.data));
      });
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    goBack() {
      this.$router.push("/income-statements");
    },

    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
  },
};
</script>
